 const Spinner = () => {

    return <span className={`spinner-border spinner-grow-sm d-inline-flex mx-auto text-success`}  role="status">
        <span className="visually-hidden"></span>
    </span>
}
export default Spinner;